module.exports = "https://img.xiyuyouxi.com/saas/img/logo.f0586048.png";